"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _antd = require("antd");

var _react = _interopRequireWildcard(require("react"));

var _TableData = _interopRequireDefault(require("./TableData"));

var _config = _interopRequireDefault(require("../../../../../config.json"));

var _axios = _interopRequireDefault(require("axios"));

var _utils = _interopRequireDefault(require("../../../../../utils"));

var _DataDisplayWidget = _interopRequireDefault(require("../Style/DataDisplayWidget"));

var _icons = require("@ant-design/icons");

var _moment = _interopRequireDefault(require("moment"));

var _DateConstant = require("../../../../../constants/DateConstant");

var _errorPage = _interopRequireDefault(require("../../../../error-views/errorPage"));

var _CardData = _interopRequireDefault(require("./CardData"));

// import { useHistory } from 'react-router';
var innerwidth = window.innerWidth; // const { Search } = Input;
// const { Option } = Select;

var date = new Date();
var year = date.getFullYear();
var month = ("0" + (date.getMonth() + 1)).slice(-2);
var day = ("0" + date.getDate()).slice(-2);
var today = "".concat(year, "-").concat(month, "-").concat(day);

var ListItem = function ListItem() {
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token"); // const history = useHistory();

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      searchEnrolledData = _useState2[0],
      setEnrolledSearchData = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      allEnrolledData = _useState4[0],
      setAllEnrolledData = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      enrolledData = _useState6[0],
      setEnrolledData = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      apiError = _useState10[0],
      setapiError = _useState10[1];

  var _useState11 = (0, _react.useState)(undefined),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      start = _useState12[0],
      setStart = _useState12[1]; //Startdate


  var _useState13 = (0, _react.useState)(today),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      end = _useState14[0],
      setEnd = _useState14[1]; //enddate
  // useEffect(async()=>{      
  //     callEnrolledDetails();
  // },[]);


  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var callEnrolledDetails, _callEnrolledDetails;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _callEnrolledDetails = function _callEnrolledDetails3() {
                  _callEnrolledDetails = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                    var url;
                    return _regenerator.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            url = _config.default.enrolledStudentApi + cl;
                            _context.next = 3;
                            return _axios.default.get(url, {
                              headers: {
                                'Authorization': token
                              }
                            }).then(function (resp) {
                              if (resp.data.status === "error") setapiError(resp.data);else {
                                resp.data.forEach(function (obj) {
                                  obj.Joining_date = dateFormate(obj.Joining_date);
                                  obj.DOB = dateFormate(obj.DOB);
                                });
                                setEnrolledData(resp.data);
                                setEnrolledSearchData(resp.data);
                                setAllEnrolledData(resp.data);
                                setLoading(false);

                                if (resp.data.length > 0) {
                                  var minDate = new Date(Math.min.apply(Math, (0, _toConsumableArray2.default)(resp.data.map(function (element) {
                                    return new Date(element.Joining_date);
                                  }))));
                                  setStart(minDate);
                                }
                              }
                            }, function (err) {
                              var obj = {
                                "status": "error",
                                "message": "Network Error"
                              };
                              if (err.response) setapiError(err.response);else setapiError(obj);
                            });

                          case 3:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));
                  return _callEnrolledDetails.apply(this, arguments);
                };

                callEnrolledDetails = function _callEnrolledDetails2() {
                  return _callEnrolledDetails.apply(this, arguments);
                };

                callEnrolledDetails();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, []);

  function dateFormate(changeDate) {
    var date = new Date(changeDate);
    var year = date.getFullYear();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    var todayDate = "".concat(year, "-").concat(month, "-").concat(day);
    return todayDate;
  }

  var onSearch = function onSearch(e) {
    var value = e.currentTarget.value;

    var searchdata = _utils.default.wildCardSearch(searchEnrolledData, value);

    setEnrolledData(searchdata);
  };

  function filterDate(str, dateString) {
    if (str === "end" && dateString) {
      setEnd(dateString);
      start = typeof start === "object" ? dateFormate(start) : start;
      setStart(start);
      var filterData = allEnrolledData.filter(function (obj) {
        return obj.Joining_date >= start && obj.Joining_date <= dateString;
      });
      setEnrolledData(filterData);
      setEnrolledSearchData(filterData);
    } else if (str === "start" && dateString) {
      setStart(dateString);

      var _filterData = allEnrolledData.filter(function (obj) {
        return obj.Joining_date >= dateString && obj.Joining_date <= end;
      });

      setEnrolledData(_filterData);
      setEnrolledSearchData(_filterData);
    } else {
      setEnrolledData(allEnrolledData);
      setEnrolledSearchData(allEnrolledData);
    }
  }

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: 16
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 20,
    xl: 20,
    xxl: 20
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Filter"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [8, 8]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 9,
    xl: 9,
    xxl: 9
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    placeholder: "Search",
    prefix: /*#__PURE__*/_react.default.createElement(_icons.SearchOutlined, null),
    onChange: function onChange(e) {
      return onSearch(e);
    }
  })), start ? /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 15,
    xl: 15,
    xxl: 15
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("b", null, "Date From : ")), /*#__PURE__*/_react.default.createElement(_antd.DatePicker, {
    defaultValue: (0, _moment.default)(start, _DateConstant.DATE_FORMAT_YYYY_MM_dd),
    onChange: function onChange(momentDate, dateString) {
      return filterDate("start", dateString);
    },
    placeholder: "Select Start Date"
  })), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("b", null, "\xA0To : ")), /*#__PURE__*/_react.default.createElement(_antd.DatePicker, {
    defaultValue: (0, _moment.default)(date, _DateConstant.DATE_FORMAT_YYYY_MM_dd_Combined),
    onChange: function onChange(momentDate, dateString) {
      return filterDate("end", dateString);
    },
    placeholder: "Select End Date"
  })))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 4,
    xl: 4,
    xxl: 4
  }, /*#__PURE__*/_react.default.createElement(_DataDisplayWidget.default, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserSwitchOutlined, null),
    value: enrolledData.length,
    title: "Enrollment Request",
    color: "cyan",
    size: "20",
    vertical: true,
    avatarSize: 30,
    style: {
      height: 132
    }
  }))), innerwidth > 425 ? /*#__PURE__*/_react.default.createElement(_TableData.default, {
    data: enrolledData
  }) : /*#__PURE__*/_react.default.createElement(_CardData.default, {
    data: enrolledData
  }));
};

var _default = ListItem;
exports.default = _default;